// extracted by mini-css-extract-plugin
export default {"boton":"EventoCrearScreen_boton__IeXz4","fixedButton":"EventoCrearScreen_fixedButton__lHqGM"};